"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const three_1 = require("three");
const utils_1 = require("~/utils/utils");
const Leader_3d_1 = __importDefault(require("./Leader.3d"));
const consts_1 = require("../consts");
class DimensioningLeader extends Leader_3d_1.default {
    drawLabelByPositionAndDistance(position, distance) {
        const distanceText = this.viewer.isImperialMeasurementUsed ? (0, utils_1.getLabelInInch)(distance) : (0, utils_1.getLabelInMM)(distance);
        this.setLabelText(distanceText, this.prefix);
        if (!this.label.isConnected) {
            this.addLabel(this.label);
        }
        this.showLabelAtPoints(position);
    }
    createLine(startPoint, endPoint) {
        const dashedLine = new three_1.LineSegments(new three_1.BufferGeometry().setFromPoints([startPoint, endPoint]), this.lineMaterial);
        dashedLine.computeLineDistances();
        const group = new three_1.Group();
        group.add(dashedLine);
        const leaderDistance = startPoint.distanceTo(endPoint);
        if (leaderDistance < consts_1.consts.ARROW_HEAD_MIN_DISPLAY_DISTANCE) {
            return group;
        }
        const leaderDirection = endPoint.clone().sub(startPoint).normalize();
        const leaderPart1 = new three_1.ArrowHelper(leaderDirection.clone(), startPoint.clone(), leaderDistance, consts_1.consts.LEADER_COLOR, consts_1.consts.ARROW_HEAD_LENGTH, consts_1.consts.ARROW_HEAD_WIDTH);
        const leaderPart2 = new three_1.ArrowHelper(leaderDirection.negate(), endPoint, leaderDistance, consts_1.consts.LEADER_COLOR, consts_1.consts.ARROW_HEAD_LENGTH, consts_1.consts.ARROW_HEAD_WIDTH);
        leaderPart1.line.removeFromParent();
        leaderPart2.line.removeFromParent();
        group.add(leaderPart1);
        group.add(leaderPart2);
        return group;
    }
}
exports.default = DimensioningLeader;
